import { Row, Col } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import {
	selectCmeFormId,
	selectFormPersonId,
	selectForm,
} from "reducers/formSlice";
import { selectPersonId } from "reducers/securitySlice";
import StatusTag from "components/StatusTag";
import { selectPerson } from "../person/personSlice";

const FormHeader = () => {
	const personId = useSelector(selectPersonId);
	const formPersonId = useSelector(selectFormPersonId);
	const person = useSelector(selectPerson);
	const formId = useSelector(selectCmeFormId);
	const { status } = useSelector(selectForm);
	return (
		formId && (
			<Row
				style={{
					fontWeight: 600,
					color: "white",
					whiteSpace: "nowrap",
					overflow: "hidden",
				}}
				align="middle"
				gutter={5}
				wrap={false}
			>
				<Col>ID: {formId}</Col>
				<Col>
					{personId !== formPersonId &&
						personId !== null &&
						formPersonId !== null && <>From {person?.fullName}</>}
				</Col>
				<Col>
					<div style={{ display: "flex", alignItems: "center" }}>
						<StatusTag status={status} />
					</div>
				</Col>
			</Row>
		)
	);
};

export default FormHeader;
